import { PdColorPicker } from "./pd-color-picker/PdColorPicker.js";
//#region src/pd-color-picker/pd-color-picker.ts
var tag = "pd-color-picker";
if (!customElements.get(tag)) customElements.define(tag, PdColorPicker);
//#endregion
export { PdColorPicker };
